import GraphqlRequestClient from './graphqlRequest.client';

export default GraphqlRequestClient;
